import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Evento } from 'src/app/eventos/evento.model';
import { MensajeComponent } from 'src/app/mensaje/mensaje.component';
import { Adicionales } from 'src/app/models/adicionales.model';
import { ClientePagos } from 'src/app/models/cliente-pagos.model';
import { Cupon } from 'src/app/models/cupon.model';
import { Localidad } from 'src/app/models/localidad.model';
import { Orden } from 'src/app/models/orden.model';
import { Ticket } from 'src/app/models/ticket.model';
import { EventoDataService } from 'src/app/service/data/evento-data.service';
import { OrdenDataService } from 'src/app/service/data/orden-data.service';
import { HardcodedAutheticationService } from 'src/app/service/hardcoded-authetication.service';
import { AuthService } from 'src/app/service/seguridad/auth.service';

@Component({
    selector: 'app-compras-pendientes',
    templateUrl: './compras-pendientes.component.html',
    styleUrls: ['./compras-pendientes.component.css'],
    standalone: false
})
export class ComprasPendientesComponent {
  cliente: ClientePagos;
  precioTotal: number[]=[];
  ordenes: Orden[] = [];
  eventos: Evento[] = [];
  localidades: Localidad[]=[];
  eventosConLocalidades: any[] = [];
  ticketsPorOrden:Ticket[][]
  orden: Orden;
  serviciosPorOrden: { [ordenId: number]: Adicionales[] } = {};
  cuponesPorOrden: { [ordenId: number]: Cupon } = {};

  correo;
  cargando: boolean;
  constructor(private dialog: MatDialog, private ordenService: OrdenDataService, private route:ActivatedRoute, private eventoService: EventoDataService, private authService: HardcodedAutheticationService){}

  ngOnInit(): void {
    this.correo = this.authService.getUsuario();
    this.ordenesEnProcesoPorCliente();

  }


  ordenesEnProcesoPorCliente(): void {
    this.cargando = true;
    this.ordenService.getAllOrdenesEnProcesoByClienteId(this.correo).subscribe({
      next: response => {
        if(response == null || response.mensaje === 'No tienes ordenes pendientes'){
          this.cargando = false;
          this.openMensaje("No tienes compras pendientes,ve a la pagina principal")
        }else{
          this.ordenes = response.ordenes;
          this.ticketsPorOrden= response.ticketsPorOrden
          this.eventos = response.info.body.eventos;
          this.localidades = response.info.body.localidades;
          this.serviciosPorOrden = response.servicioOrdenes;
          this.cuponesPorOrden = response.cupones;
          this.cargando = false;
        }

      },
      error: err => {
        this.cargando = false;
        this.openMensaje("Error,vuelve a la pagina principal")
      }

    });
  }


  darImagenTipo1(evento:Evento){
    const primeraImagenTipo1 = evento.imagenes.find(imagen => imagen.tipo === 1);
    var urlPrimeraImagenTipo1 = "";
    if (primeraImagenTipo1) {
      urlPrimeraImagenTipo1 = primeraImagenTipo1.url;
    }
    return urlPrimeraImagenTipo1
  }

  getTotalTickets(i: number): number {

    const cupon= this.getCuponDeOrden(this.ordenes[i].id);
    let total: number =0;

    if(cupon!=null){
      total = this.ticketsPorOrden[i].reduce((total, ticket) => {
        let precioTicket:number=0;
        if(ticket.precio!=0){
          precioTicket = (+ticket.precio || 0) + (+ticket.servicio || 0) + (+ticket.servicio_iva || 0);
          ticket.precio = cupon.precio
          ticket.servicio_iva = cupon.iva
          ticket.servicio=cupon.servicio
        }
        return total + precioTicket;
      }, 0);

    }
    else{
      total = this.ticketsPorOrden[i].reduce((total, ticket) => {
        const precioTicket = (+ticket.precio || 0) + (+ticket.servicio || 0) + (+ticket.servicio_iva || 0);
        return total + precioTicket;
      }, 0);
    }
    return total;
  }


  getServiciosPorOrden(ordenId: number): Adicionales[] {
    if(this.serviciosPorOrden){
      return this.serviciosPorOrden[ordenId];
    }
    else{
      return []
    }

  }

  getCuponDeOrden(ordenId: number): Cupon | null {
    if (!this.cuponesPorOrden) {
      return null;
    }
    const cupon = this.cuponesPorOrden[ordenId];
    return cupon || null;
  }

  getTotalServicios(ordenId: number): number {
    return this.getServiciosPorOrden(ordenId).reduce((total, servicio) => total + (+servicio.precio+servicio.servicio+servicio.servicioIva || 0), 0);
  }

  getTotalGeneral(i: number, ordenId: number): number {
    let total: number=0;
    total+= this.getTotalTickets(i) + (this.getTotalServicios(ordenId)*this.ticketsPorOrden[i].length);
    if(this.ordenes[i].seguro&&this.ordenes[i].seguro>0){
      total+=this.ordenes[i].seguro;
    }
    return total;
  }
  openMensaje(mensajeT: string, openD?: string): void {
    let screenWidth = screen.width;
    let anchoDialog: string = '500px';
    let anchomax: string = '80vw';
    let altoDialog: string = '250';
    if (screenWidth <= 600) {
      anchoDialog = '100%';
      anchomax = '100%';
      altoDialog = 'auto';
    }
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: anchoDialog,
      maxWidth: anchomax,
      height: altoDialog,
      data: {
        mensaje: mensajeT,
      },
    });
  }

}
